import React, { useMemo } from 'react';

// Reusable loading skeleton used across admin pages
export default React.memo(function LoadingSkeleton() {
  const rows = useMemo(() => Array.from({ length: 6 }), []);
  return (
    <div className="p-4 space-y-3">
      <div className="h-7 w-40 bg-gray-200 animate-pulse rounded" />
      <div className="h-10 w-full bg-gray-200 animate-pulse rounded" />
      <div className="space-y-2">
        {rows.map((_, i) => (
          <div key={i} className="h-10 w-full bg-gray-100 animate-pulse rounded" />
        ))}
      </div>
    </div>
  );
});
